import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelCheckbox as _vModelCheckbox, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-1720bff7"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "main"
};
const _hoisted_2 = {
  class: "holder"
};
const _hoisted_3 = {
  key: 0,
  class: "sell"
};

const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("h2", {
  class: "title"
}, " Продать работу ", -1));

const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "sell-text"
}, " Вы можете предложить работу художнику только из списка ниже. Это поле является обязательным ", -1));

const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "label"
}, "Художник", -1));

const _hoisted_7 = {
  class: "select-item"
};
const _hoisted_8 = {
  ref: "authorId",
  class: "styled"
};

const _hoisted_9 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("option", {
  value: ""
}, " Выберите художника из списка ", -1));

const _hoisted_10 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("option", {
  value: ""
}, " В списке нет этого художника ", -1));

const _hoisted_11 = ["value"];
const _hoisted_12 = {
  class: "upload"
};
const _hoisted_13 = ["src"];
const _hoisted_14 = {
  key: 1,
  class: "upload-label"
};
const _hoisted_15 = ["src"];

const _hoisted_16 = /*#__PURE__*/_createTextVNode(" Загрузить фото ");

const _hoisted_17 = {
  class: "user-info"
};

const _hoisted_18 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "form-title"
}, " Персональная информация ", -1));

const _hoisted_19 = {
  class: "input-line"
};
const _hoisted_20 = {
  class: "input-col"
};

const _hoisted_21 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "label"
}, "Имя", -1));

const _hoisted_22 = {
  class: "input-col"
};

const _hoisted_23 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "label"
}, "Телефон", -1));

const _hoisted_24 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "label"
}, "Email", -1));

const _hoisted_25 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "label"
}, "Комментарий", -1));

const _hoisted_26 = {
  class: "form-policy check-item"
};

const _hoisted_27 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "ch1",
  class: "check-label"
}, [/*#__PURE__*/_createTextVNode("ознакомлен и согласен с "), /*#__PURE__*/_createElementVNode("a", {
  href: "/agreement",
  target: "_blank"
}, "политикой обработки данных")], -1));

const _hoisted_28 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  class: "button"
}, " Отправить ", -1));

const _hoisted_29 = {
  key: 1,
  class: "finish"
};
const _hoisted_30 = {
  class: "finish-img"
};
const _hoisted_31 = ["src"];

const _hoisted_32 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "finish-title"
}, " Ваша предложение отправлено ", -1));

const _hoisted_33 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "finish-text"
}, " Мы обрабатываем ваше предложение и скоро дадим ответ о выставлении работы на продажу. Вам придет уведомление на почту ", -1));

const _hoisted_34 = /*#__PURE__*/_createTextVNode(" Вернуться на главную ");

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_upload = _resolveComponent("el-upload");

  const _component_input_phone_component = _resolveComponent("input-phone-component");

  const _component_router_link = _resolveComponent("router-link");

  return _openBlock(), _createElementBlock("section", _hoisted_1, [_createElementVNode("div", _hoisted_2, [!$data.finish ? (_openBlock(), _createElementBlock("div", _hoisted_3, [_hoisted_4, _hoisted_5, _createElementVNode("form", {
    onSubmit: _cache[5] || (_cache[5] = _withModifiers((...args) => $options.handlerSubmit && $options.handlerSubmit(...args), ["prevent"]))
  }, [_createElementVNode("fieldset", null, [_hoisted_6, _createElementVNode("div", _hoisted_7, [_createElementVNode("select", _hoisted_8, [_hoisted_9, _hoisted_10, (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.authors, Author => {
    return _openBlock(), _createElementBlock("option", {
      key: Author.id,
      value: Author.id
    }, _toDisplayString(Author.name), 9, _hoisted_11);
  }), 128))], 512)]), _createElementVNode("div", _hoisted_12, [_createVNode(_component_el_upload, {
    class: _normalizeClass(["avatar-uploader", {
      'img': $data.image
    }]),
    "show-file-list": false,
    "on-change": $options.handlerSelectPhoto,
    "auto-upload": false
  }, {
    default: _withCtx(() => [$data.image ? (_openBlock(), _createElementBlock("img", {
      key: 0,
      src: $data.image,
      class: "image",
      alt: ""
    }, null, 8, _hoisted_13)) : (_openBlock(), _createElementBlock("label", _hoisted_14, [_createElementVNode("img", {
      src: require('@/frontend/assets/images/paperclip.svg'),
      alt: ""
    }, null, 8, _hoisted_15), _hoisted_16]))]),
    _: 1
  }, 8, ["class", "on-change"])]), _createElementVNode("div", _hoisted_17, [_hoisted_18, _createElementVNode("div", _hoisted_19, [_createElementVNode("div", _hoisted_20, [_hoisted_21, _withDirectives(_createElementVNode("input", {
    "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $data.form.name = $event),
    type: "text",
    class: "input",
    placeholder: "Введите имя"
  }, null, 512), [[_vModelText, $data.form.name]])]), _createElementVNode("div", _hoisted_22, [_hoisted_23, _createVNode(_component_input_phone_component, {
    modelValue: $data.form.phone,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => $data.form.phone = $event),
    class: "input"
  }, null, 8, ["modelValue"])])]), _hoisted_24, _withDirectives(_createElementVNode("input", {
    "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => $data.form.email = $event),
    type: "text",
    class: "input",
    placeholder: "Введите email"
  }, null, 512), [[_vModelText, $data.form.email]]), _hoisted_25, _withDirectives(_createElementVNode("textarea", {
    "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => $data.form.comment = $event),
    cols: "30",
    rows: "10",
    class: "textarea",
    placeholder: "Введите комментарий"
  }, null, 512), [[_vModelText, $data.form.comment]]), _createElementVNode("div", _hoisted_26, [_withDirectives(_createElementVNode("input", {
    id: "ch1",
    "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => $data.agreePolicy = $event),
    type: "checkbox",
    class: "check-input"
  }, null, 512), [[_vModelCheckbox, $data.agreePolicy]]), _hoisted_27]), _hoisted_28])])], 32)])) : (_openBlock(), _createElementBlock("div", _hoisted_29, [_createElementVNode("div", _hoisted_30, [_createElementVNode("img", {
    src: require('@/frontend/assets/images/finish-img.svg'),
    alt: ""
  }, null, 8, _hoisted_31)]), _hoisted_32, _hoisted_33, _createVNode(_component_router_link, {
    to: {
      name: 'main'
    },
    class: "button"
  }, {
    default: _withCtx(() => [_hoisted_34]),
    _: 1
  })]))])]);
}